import { Input } from 'antd-mobile';
import { useEffect, useRef, useState } from 'react';
import './index.scss';
import HdlToast from '@/utils/toast';
import BaseModal from '@/components/BaseModal';
import SliderModal from '@/components/SliderModal';
import { setDocumentTitle } from '@/utils';
import { useNavigate, useParams } from 'react-router-dom';
import api from '@/api';
import wxPromisify from '@/libs/promiseWx/wxPromisify';
import dayjs from 'dayjs';
import ErrorIndex from '@/components/ErrorIndex';
import pathConfig from '@/utils/pathConfig';

let isCoupon = false;
let timer: string | number | NodeJS.Timeout | undefined;
const ACTIVITY_UN_START = 1; // 活动未开始
const ACTIVITY_IS_END = 2; // 活动已结束
const Login = () => {
  const [checked, setChecked] = useState<boolean>(false);
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState<any>();
  const [coding, setCoding] = useState(false);
  const [yztime, setYztime] = useState(59);
  const [show, setShow] = useState<boolean>(false); //是否展示
  const [activity, setActivity] = useState<any>(); // 活动信息
  const [isLogin, setIsLogin] = useState<boolean>(false); // 是否允许登陆
  const [errorIndex, setErrorIndex] = useState<any>(); // 错误信息
  const loadingRef = useRef<any>(); //loading
  const navigate = useNavigate();
  const urlParam: any = useParams();

  useEffect(() => {
    // 查询活动信息
    getActivity(urlParam);
  }, []);

  const getActivity = async (urlParam: { id: '' }) => {
    if (urlParam.id) {
      const param = { actId: urlParam.id };
      try {
        const res: any = await api.login.getActivityCommunityById(param);
        setDocumentTitle(res?.activityName);
        // 活动未开始
        if (res.actStatus === ACTIVITY_UN_START) {
          setIsLogin(false);
          setErrorIndex({
            errorTitle: res?.activityName, // 标题
            errorInfo: `活动将在${
              res.startTime
                ? dayjs(res.startTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }开始，敬请期待～`,
            imgChild: (
              <img
                src={require('@/images/common/not_started.png')}
                alt="活动已结束"
                className="error-img"
              />
            ), //图片
            clicButton: (
              <div className="clic-Button">
                <span>进入海底捞外送小程序查看更多优惠活动</span>
              </div>
            ),
          });
        }
        // 活动已结束
        else if (res.actStatus === ACTIVITY_IS_END) {
          setErrorIndex({
            errorTitle: res?.activityName, // 标题
            errorInfo: '活动已结束，感谢您的关注～',
            imgChild: (
              <img
                src={require('@/images/common/over.png')}
                alt="活动已结束"
                className="error-img"
              />
            ), //图片
            clicButton: (
              <div className="clic-Button">
                <span>进入海底捞外送小程序查看更多优惠活动</span>
              </div>
            ),
          });
          setIsLogin(false);
        } else {
          setIsLogin(true);
          setActivity(res);
        }

        //设置分享
        const { mainTitle, subTitle, picture } = res;
        wxPromisify.setShareData({
          title: mainTitle, // 分享标题
          desc: subTitle, // 分享描述
          link: window.location.href,
          imgUrl: picture,
        });
      } catch (error: any) {
        console.log(error);
      }
    }
  };

  // 获取验证码
  const handleGetCode = () => {
    if (validatePhone()) {
      // 滑块弹框
      loadingRef.current.open();
    }
  };

  const count = () => {
    timer = setInterval(() => setYztime((pre) => pre - 1), 1000);
    setCoding(true);
  };
  useEffect(() => {
    clearInterval(timer);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!(yztime > 0 && yztime < 59)) {
      clearInterval(timer);
      setCoding(false);
      setYztime(59);
    }
  }, [yztime]);

  // 领取优惠券
  const handleGetCoupon = async () => {
    if (validatePhone() && validateCode()) {
      if (!checked) {
        HdlToast.info('请勾选同意《用户许可使用权益》和《隐私政策》');
      } else {
        if (isCoupon) {
          return;
        }
        isCoupon = true;
        sessionStorage.setItem('couponInfo', JSON.stringify(activity));
        try {
          const param = {
            mobile: phone.replace(/\s+/g, ''),
            code: code,
            companyId: 1,
            actId: urlParam.id,
            staffId: urlParam.staffId, //员工id
          };
          const coupon: any = await api.login.sendPromotionCouponStaff(param);
          isCoupon = false;
          navigate('/customerCoupon/' + urlParam.staffId + '/' + coupon);
        } catch (error: any) {
          isCoupon = false;
          if (error.data.code === 500) {
            HdlToast.info(error.data.msg);
          } else {
            console.log(999, error.data.code);
            navigate('/customerError/' + error.data.code);
          }
        } finally {
          isCoupon = false;
        }
      }
    }
  };
  const validatePhone = () => {
    if (!phone) {
      HdlToast.info('手机号不能为空');
      return false;
    }
    const mobile = phone.replace(/\s+/g, '');
    const reg = new RegExp(/^1[23456789]\d{9}$/);
    if (mobile.length !== 11 || !reg.test(mobile)) {
      HdlToast.info('请输入正确的11位手机号');
      return false;
    }
    return true;
  };

  const validateCode = () => {
    if (!code) {
      HdlToast.info('验证码错误');
      return false;
    }
    return true;
  };

  const formatePhone = (val: string) => {
    const newVal = val.replace(/\s+/g, '');
    const reg = new RegExp(/^1[3456789]\d{9}$/);
    if (reg.test(val) && newVal.length === 11) {
      const value = val.replace(/(\d{3})(\d{0,4})(\d{0,4})/, '$1 $2 $3');
      setPhone(value);
    } else {
      setPhone(val);
    }
  };
  const activityRules = () => {
    setShow(true);
  };
  const closeModal = () => {
    setShow(false);
  };

  // 发送验证码接口
  const sendCode = async (params: any) => {
    const param = {
      mobile: phone.replace(/\s+/g, ''),
      sessionId: params?.ydSessionId,
      sig: params?.ydSig,
      token: params?.ydToken,
      scene: params?.ydScene,
    };
    try {
      await api.login.sendMessageCodeStaff(param);
      count();
    } catch (error: any) {
      console.log(error);
    }
  };

  return isLogin ? (
    <>
      <div className="login">
        <img
          src={require('@/images/common/login_bg_top.png')}
          alt=""
          className="login-bg-top"
        />
        <img
          src={require('@/images/common/login-title.png')}
          alt=""
          className="login-title-img"
        />
        <div className="no-regiester">未注册手机号领取后自动创建账号</div>
        <img
          src={require('@/images/common/activity-rules.png')}
          alt="活动规则"
          className="login-rules"
          onClickCapture={activityRules}
        />
        <div className="login-contents">
          <div className="login-form">
            <div className="login-phone">
              <span className="title">+86</span>
              <div className="input-phone">
                {!phone ? (
                  <span className="placeholder">请输入手机号</span>
                ) : (
                  ''
                )}
                <Input
                  value={phone}
                  type="tel"
                  pattern="[0-9]*"
                  clearable
                  onChange={(val) => {
                    setPhone(val.replace(/[^\d]/g, ''));
                  }}
                  onBlur={(val) => formatePhone(val.target.value)}
                />
              </div>
            </div>
            <div className="login-code">
              <div className="code-content">
                <span className="title">验证码</span>
                <div className="input-code">
                  {!code ? (
                    <span className="placeholder">请输入验证码</span>
                  ) : (
                    ''
                  )}
                  <Input
                    className="inputs"
                    clearable
                    type="tel"
                    pattern="[0-9]*"
                    onChange={(val) => {
                      if (val && val.length > 6) {
                        setCode(val.slice(0, 6));
                      } else {
                        setCode(val);
                      }
                    }}
                    maxLength={6}
                    autoComplete="one-time-code"
                  />
                </div>
                {coding ? (
                  <div className={'extraPart reSetCode'}>
                    {yztime + 's后重发'}
                  </div>
                ) : (
                  <div
                    className={phone ? 'extraPart' : 'reSetCode'}
                    onClickCapture={handleGetCode}
                  >
                    获取验证码
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="login-check">
            {!checked ? (
              <div
                className="no-checked-box"
                onClickCapture={() => {
                  setChecked(true);
                }}
              >
                <div className="no-checked"></div>
              </div>
            ) : (
              <img
                src={require('@/images/common/login_checked.png')}
                className="login-checkbox"
                onClickCapture={() => {
                  setChecked(false);
                }}
              />
            )}
            <span className="login-check-content">
              登录/注册表示同意
              <span
                className="light"
                onClickCapture={() => {
                  window.open(pathConfig.YHXKXY_URL);
                }}
              >
                用户许可使用协议
              </span>{' '}
              和{' '}
              <span
                className="light"
                onClickCapture={() => {
                  window.open(pathConfig.YSZC_URL);
                }}
              >
                隐私政策
              </span>
            </span>
          </div>
          <div
            className={
              !!phone && code && code.length === 6
                ? 'login-btn login-btn-light'
                : 'login-btn'
            }
            onClickCapture={!!phone && !!code ? handleGetCoupon : () => ''}
          >
            <span>领取优惠券</span>
          </div>
        </div>
        <div className="login-bg-content">
          <img
            src={require('@/images/common/login_bg_bottom.png')}
            alt=""
            className="login-bg-bottom"
          />
        </div>
        <BaseModal show={show}>
          <div className="rules">
            <img
              src={require('@/images/common/rule-close.png')}
              className="rule-close"
              onClickCapture={closeModal}
            ></img>
            <div className="rules-title">活动规则</div>
            <div className="rules-content">{activity?.rule} </div>
          </div>
        </BaseModal>
        <SliderModal
          cRef={loadingRef}
          sendCode={sendCode}
          phone={phone ? Number(phone) : undefined}
        ></SliderModal>
      </div>
    </>
  ) : (
    <div className="coupon-Error">
      <ErrorIndex
        imgChild={errorIndex?.imgChild}
        title={errorIndex?.errorTitle}
        info={errorIndex?.errorInfo}
        clicButton={errorIndex?.clicButton}
      ></ErrorIndex>
    </div>
  );
};
export default Login;
